import React, { useState } from "react";

const getBackgroundImageURL = async () => {
  return "/assets/images/2.jpg";
};

const calculateImagePosition = (userImg, bgImg) => {
  const whiteAreaWidth = 872;
  const whiteAreaHeight = 920;
  const dpi = 30.8;
  const margin = 0.3 * dpi;
  const finalWidth = whiteAreaWidth - 2 * margin;
  const finalHeight = whiteAreaHeight - 2 * margin;

  const whiteAreaX = (bgImg.width - whiteAreaWidth) / 2;
  const whiteAreaY = (bgImg.height - whiteAreaHeight) / 2;

  const scale = Math.min(
    finalWidth / userImg.width,
    finalHeight / userImg.height
  );
  const newWidth = userImg.width * scale;
  const newHeight = userImg.height * scale;
  const x = whiteAreaX + (whiteAreaWidth - newWidth) / 2;
  const y = whiteAreaY + (whiteAreaHeight - newHeight) / 2;

  return { x, y, width: newWidth, height: newHeight };
};

const generateComposedImage = async (userImgSrc) => {
  const bgUrl = await getBackgroundImageURL();
  const bgImg = new window.Image();
  const userImg = new window.Image();

  await new Promise((resolve) => {
    bgImg.onload = resolve;
    bgImg.src = bgUrl;
  });
  await new Promise((resolve) => {
    userImg.onload = resolve;
    userImg.src = userImgSrc;
  });

  const canvas = document.createElement("canvas");
  canvas.width = bgImg.width;
  canvas.height = bgImg.height;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(bgImg, 0, 0);

  const pos = calculateImagePosition(userImg, bgImg);
  ctx.drawImage(userImg, pos.x, pos.y, pos.width, pos.height);

  return canvas.toDataURL("image/jpeg");
};

export default function ExamPhotoUploadBox({
  user,
  refreshUserData,
  uploadInstagramPhotoToDb,
  saveUserData,
}) {
  const [examPhoto, setExamPhoto] = useState(user?.examPhoto || "");
  const [isUploading, setIsUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedFile(e.target.files[0]);
      setSuccessMsg("");
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Lütfen bir fotoğraf seçin.");
      return;
    }
    setIsUploading(true);
    const reader = new FileReader();
    reader.onloadend = async () => {
      try {
        const userImgSrc = reader.result;
        const composedBase64 = await generateComposedImage(userImgSrc);
        const base64String = composedBase64.split(",")[1];
        const url = await uploadInstagramPhotoToDb(
          base64String,
          user.uid + ".jpg"
        );
        setExamPhoto(url);
        await saveUserData(user.uid, { examPhoto: url });
        await refreshUserData();
        setSuccessMsg("Fotoğraf başarıyla yüklendi.");
        setSelectedFile(null);
        setTimeout(() => setSuccessMsg(""), 2500);
      } catch (err) {
        console.error("Fotoğraf yüklenirken hata oluştu:", err);
        alert("Fotoğraf yüklenirken hata oluştu: " + (err?.message || err));
      }
      setIsUploading(false);
    };
    reader.readAsDataURL(selectedFile);
  };

  return (
    <div
      style={{
        borderRadius: 20,
        padding: 32,
        margin: "36px auto",
        border: "1.5px solid #e0e0e0",
        background: "linear-gradient(135deg, #f8fafc 0%, #f5f5f5 100%)",
        maxWidth: 420,
        boxShadow: "0 6px 32px #582b7112, 0 1.5px 8px #7c3aed11",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          padding: "0px 18px",
          marginBottom: 22,
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            marginBottom: 4,
          }}
        >
          <span style={{ fontSize: 28, color: "#7c3aed" }}>🌟</span>
          <span
            style={{
              fontWeight: 700,
              fontFamily: "'Montserrat', Arial, sans-serif",
              fontSize: "1.3rem",
              letterSpacing: 0.5,
              color: "#582b71",
            }}
          >
            OYUN 2025'e Katıldığını Göster!
          </span>
        </div>
        <div
          style={{
            fontStyle: "italic",
            color: "#444",
            fontSize: "1.02rem",
            fontWeight: 400,
            marginTop: 2,
            marginBottom: 2,
            fontFamily: "'Montserrat', Arial, sans-serif",
          }}
        >
          Fotoğrafını yükle, Instagram'da paylaş,{" "}
          <b style={{ color: "#7c3aed" }}>#oyun2025</b> ve{" "}
          <a
            href="https://www.instagram.com/zekavakfi/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#582b71",
              textDecoration: "underline",
              fontWeight: "bold",
            }}
          >
            @zekavakfi
          </a>{" "}
          etiketlerini eklemeyi unutma!
        </div>
      </div>

      <div
        style={{
          width: 220,
          borderRadius: "16px",
          background: "#fff",
          boxShadow: "0 2px 12px #7c3aed11, 0 1.5px 8px #582b7111",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 18,
          overflow: "hidden",
          position: "relative",
          border: "2px solid #e0e0e0",
          transition: "box-shadow 0.3s, border 0.3s",
        }}
      >
        {examPhoto ? (
          <img
            src={examPhoto}
            alt="Sınav Katılım Fotoğrafı"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "14px",
              transition: "box-shadow 0.3s",
            }}
          />
        ) : (
          <span
            style={{
              color: "#a78bfa",
              fontSize: 60,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              opacity: 0.7,
            }}
          >
            📷
          </span>
        )}
      </div>

      <input
        type="file"
        accept="image/png, image/jpg, image/jpeg"
        onChange={handleFileChange}
        disabled={isUploading}
        style={{
          marginBottom: 12,
          marginTop: 8,
          fontSize: 15,
          borderRadius: 8,
          border: "1.5px solid #a78bfa",
          padding: "7px 12px",
          background: "#f8fafc",
          color: "#582b71",
          cursor: isUploading ? "not-allowed" : "pointer",
          width: "100%",
          maxWidth: 300,
          fontFamily: "'Montserrat', Arial, sans-serif",
          boxShadow: "0 1.5px 8px #a78bfa11",
          transition: "border 0.2s, box-shadow 0.2s",
        }}
      />
      <button
        onClick={handleUpload}
        disabled={isUploading || !selectedFile}
        style={{
          background:
            isUploading || !selectedFile
              ? "#e0e7ff"
              : "linear-gradient(90deg, #7c3aed 0%, #a78bfa 100%)",
          color: isUploading || !selectedFile ? "#aaa" : "#fff",
          border: "none",
          borderRadius: 8,
          padding: "9px 0",
          fontSize: 16,
          fontWeight: 700,
          cursor: isUploading || !selectedFile ? "not-allowed" : "pointer",
          marginTop: 8,
          minWidth: 180,
          boxShadow:
            isUploading || !selectedFile ? "none" : "0 2px 8px #7c3aed22",
          transition: "background 0.2s, color 0.2s, box-shadow 0.2s",
          fontFamily: "'Montserrat', Arial, sans-serif",
          letterSpacing: 0.3,
        }}
      >
        {isUploading ? (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span
              className="loader"
              style={{
                width: 16,
                height: 16,
                border: "3px solid #fff",
                borderTop: "3px solid #a78bfa",
                borderRadius: "50%",
                display: "inline-block",
                animation: "spin 1s linear infinite",
              }}
            ></span>
            Yükleniyor...
          </span>
        ) : successMsg ? (
          <span style={{ color: "#43a047", fontWeight: 700 }}>
            &#10003; {successMsg}
          </span>
        ) : (
          "Fotoğraf Yükle"
        )}
      </button>
      {examPhoto && (
        <button
          style={{
            marginTop: 14,
            background: "linear-gradient(90deg, #fbbf24 0%, #f472b6 100%)",
            color: "#582b71",
            border: "none",
            borderRadius: 8,
            padding: "9px 0",
            fontSize: 16,
            fontWeight: 700,
            cursor: "pointer",
            minWidth: 160,
            boxShadow: "0 2px 8px #fbbf2411",
            fontFamily: "'Montserrat', Arial, sans-serif",
            letterSpacing: 0.3,
            transition: "background 0.2s, color 0.2s, box-shadow 0.2s",
          }}
          onClick={() => {
            const link = document.createElement("a");
            link.href = examPhoto;
            link.download = "oyun2025-fotograf.jpg";
            link.click();
          }}
        >
          Fotoğrafı İndir
        </button>
      )}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        button:hover:not(:disabled) {
          filter: brightness(1.08) saturate(1.1);
          box-shadow: 0 4px 16px #7c3aed33;
        }
        input[type="file"]:hover:not(:disabled) {
          border-color: #7c3aed;
          box-shadow: 0 2px 8px #a78bfa22;
        }
      `}</style>
    </div>
  );
}
